import React from 'react';

import CSSModules from 'react-css-modules';

import Heading from '../../TextComponents/Heading';
import Text from '../../TextComponents/Text';
import {createMarkup} from '../../utils/markdownUtils';

import styles from './styles.module.scss';

type LearningOutcomesProps = {
  title?: string;
  titlePlaceholder?: string;
  outcomes?: string[];
  outcomesPlaceholder?: string;
  cheer?: string;
  hovered?: boolean;
  reskinClassName?: string;
};

// eslint-disable-next-line complexity
const LearningOutcomes = ({
  title,
  titlePlaceholder,
  outcomes,
  outcomesPlaceholder,
  cheer,
  hovered,
  reskinClassName = '',
}: LearningOutcomesProps): JSX.Element => {
  const outcomeItems =
    outcomes &&
    outcomes.map((outcome, idx) => (
      <li
        dangerouslySetInnerHTML={createMarkup(outcome)}
        key={idx}
        data-automation='component-outcome-element'
      />
    ));
  const purpleTopStyle = 'purpleTop' + (hovered ? ' hovered' : '');
  const hasOutcomes = outcomeItems && outcomeItems.length > 0;

  return (
    <div styleName={reskinClassName}>
      <div styleName={purpleTopStyle} />
      <div styleName='enhancedList'>
        <div styleName='introTitle'>
          <Heading
            as='h2'
            size='cat'
            weight='medium'
            colour={title ? 'textPrimary' : 'grey300'}
            dataAutomation='component-title'
          >
            {title || titlePlaceholder || ''}
          </Heading>
        </div>
        <div>
          <div>
            {hasOutcomes && (
              <ul data-automation='component-outcome-list'>{outcomeItems}</ul>
            )}
            {!hasOutcomes && (
              <div styleName='noOutcomeWrapper'>
                <Text size='m' weight='regular' colour='grey300'>
                  {outcomesPlaceholder}
                </Text>
              </div>
            )}
            {cheer && (
              <span
                data-automation='component-description'
                dangerouslySetInnerHTML={createMarkup(cheer)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CSSModules(LearningOutcomes, styles, {allowMultiple: true});
